import { Flex, Text, Button } from '@skin-seoul/design-system';
import { useState } from 'react';
import { TrackOrderModal } from '../TrackOrderModal';

export const DeliveryTrackingBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleTrackDelivery = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <Flex width="100%" backgroundColor="neutral.75" alignItems="center" justifyContent="center">
      <Flex
        maxWidth="1280px"
        width="100%"
        paddingX={{ base: 4, desktop: 16 }}
        paddingY={6}
        alignItems="center"
        justifyContent="center"
        gap={{ base: 3, tablet: 4 }}
        flexDirection="column"
      >
        <Text
          color="neutral.700"
          textStyle={{ base: 'heading.h6.mobile', tablet: 'heading.h6' }}
          fontWeight="medium"
          textAlign="center"
        >
          Want to track your order as a guest?
        </Text>
        <Button
          onClick={handleTrackDelivery}
          backgroundColor="generic.100"
          color="generic.0"
          textStyle={{ base: 'label.medium', tablet: 'label.large' }}
          fontWeight="medium"
          paddingX={4}
          paddingY={2}
          borderRadius="8px"
          flexShrink={0}
          type="button"
          _hover={{
            backgroundColor: 'neutral.800',
          }}
          _active={{
            backgroundColor: 'neutral.900',
          }}
        >
          Track Delivery
        </Button>
        <TrackOrderModal isOpen={isModalOpen} onClose={handleModalClose} />
      </Flex>
    </Flex>
  );
};
